import { LINE_ITEM_CATEGORY_LABELS } from "@prism/shared/constants";

const LABELS = LINE_ITEM_CATEGORY_LABELS;
const ORDER = Object.keys(LABELS);

/** Public line-item table grouped by category. `lineItems` = publicProposalShape().lineItems. */
export function ScopeTable({ lineItems }) {
  const groups = new Map();
  for (const li of lineItems || []) {
    const c = LABELS[li.category] ? li.category : "other";
    if (!groups.has(c)) groups.set(c, []);
    groups.get(c).push(li);
  }
  const ordered = ORDER.filter((c) => groups.has(c));
  if (ordered.length === 0) return <p className="text-[13px] text-text-muted">No line items.</p>;
  return (
    <div className="space-y-4">
      {ordered.map((c) => (
        <div key={c}>
          <div className="text-[10px] uppercase font-medium text-text-muted mb-1" style={{ letterSpacing: "0.5px" }}>{LABELS[c]}</div>
          <table className="w-full text-[13px] border-collapse" style={{ fontFeatureSettings: "'tnum'" }}>
            <tbody>
              {groups.get(c).slice().sort((a, b) => a.sortOrder - b.sortOrder).map((li, i) => (
                <tr key={i} className="border-b border-border-light align-top">
                  <td className="py-2 pr-3">
                    <div className="font-medium text-text-primary">{li.serviceName}</div>
                    {li.description && <div className="text-[12px] text-text-secondary mt-0.5 whitespace-pre-line">{li.description}</div>}
                  </td>
                  <td className="py-2 text-right whitespace-nowrap text-text-primary">{li.feeSummary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
